var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.JobNumber"),
                  name: "jobNoConfigList"
                }
              },
              [
                !_vm.userNewJobNoRule
                  ? _c("no-config-list", {
                      attrs: {
                        "tab-name": "JobNo",
                        "tab-title": _vm.$t("SystemMaintenance.JobNumber"),
                        "tab-number-title": _vm.$t(
                          "SystemMaintenance.JobNumber"
                        ),
                        "max-length": 19,
                        "show-depart": true,
                        "show-warehouse-code": true,
                        "show-partner-warehouse-code": true,
                        "default-pattern":
                          "${office}${salesDepart}${opDepart}${lob}${port}${Y}${M}${SSSSS:ON}",
                        remark: _vm.$t("SystemMaintenance.NoteMainAndSplit19"),
                        "show-custom-job-type": true
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.MainOrderNumber"),
                  name: "mblNoConfigList"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "MblNo",
                    "tab-title": _vm.$t("SystemMaintenance.MainOrderNumber"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.MainOrderNumber"
                    ),
                    "max-length": 16,
                    "is-mbl": true,
                    "show-hbl-lob": true,
                    "show-job-sequence": true,
                    "show-job-no": true,
                    "show-port": false,
                    "show-date": false,
                    "default-pattern":
                      "${office}${salesDepart}${opDepart}${lob}${port}${Y}${M}${SSSSS:ON}",
                    remark: _vm.$t("SystemMaintenance.NoteNumberIsUpLong")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.SubOrderNumber"),
                  name: "hblNoConfig"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "HblNo",
                    "tab-title": _vm.$t("SystemMaintenance.SubOrderNumber"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.SubOrderNumber"
                    ),
                    "max-length": 21,
                    "show-hbl-lob": true,
                    "show-lob": false,
                    "show-port": false,
                    "show-job-no": true,
                    "show-date": false,
                    "show-job-sequence": true,
                    "show-partner-warehouse-code": true,
                    "show-random-letters": true,
                    "default-pattern": "${jobNo}",
                    remark: _vm.$t("SystemMaintenance.NoteIsUpToLong")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.WarehouseEntryNumber"),
                  name: "warehouseNoConfigList"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "WareHouseNo",
                    "tab-title": _vm.$t("SystemMaintenance.BookingNumber"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.WarehouseEntryNumber"
                    ),
                    "max-length": 21,
                    "show-office": false,
                    "show-job-no": true,
                    "show-date": false,
                    "show-job-sequence": true,
                    "show-warehouse-no": true,
                    "show-partner-warehouse-code": true,
                    "is-warehouse": true,
                    "default-pattern": "${port}${JJJJJ}",
                    remark: _vm.$t(
                      "SystemMaintenance.NoteYouHaveSelectedLength"
                    )
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.DomesticBill"),
                  name: "BillingInternalNoConfigList"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "BillingInternalNo",
                    "tab-title": _vm.$t("SystemMaintenance.DomesticBillNo"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.DomesticBillNo"
                    ),
                    "show-op": false,
                    "show-lob": false,
                    "show-net-code": true,
                    "show-user-code": false,
                    "show-port": false,
                    "show-io": true,
                    "show-bill-date": true,
                    "default-pattern":
                      "${office}${netCode}${Y}${M}${SSSSS:N}${io}",
                    remark: _vm.$t("SystemMaintenance.NoteIsUpToLong4")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.OverseasBillNumber"),
                  name: "billingNoConfigList"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "BillingNo",
                    "tab-title": _vm.$t("SystemMaintenance.OverseasBillNumber"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.OverseasBillNumber"
                    ),
                    "show-lob": false,
                    "show-net-code": true,
                    "show-port": false,
                    "show-io": true,
                    "show-bill-date": true,
                    "default-pattern":
                      "${office}${netCode}${Y}${M}${SSSSS:N}${io}",
                    remark: _vm.$t("SystemMaintenance.NoteIsUpToLong2")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.PaymentApplicationForm"),
                  name: "billPaymentNoConfigList"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "BillPaymentNo",
                    "tab-title": _vm.$t(
                      "SystemMaintenance.PaymentApprovalForm"
                    ),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.PaymentApplicationForm"
                    ),
                    "show-lob": false,
                    "show-port": false,
                    "show-op": false,
                    "default-pattern": "${office}${YY}${MM}${DD}${SSS:OD}",
                    remark: _vm.$t("SystemMaintenance.NoteIsUpToLong3")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.BillOfLadingSerialNumber"),
                  name: "billNoConfig"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "BillNo",
                    "tab-title": _vm.$t(
                      "SystemMaintenance.BillOfLadingSerialNumber"
                    ),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.BillOfLadingSerialNumber"
                    ),
                    "show-hbl-lob": true,
                    "show-lob": false,
                    "show-port": false,
                    "show-job-no": true,
                    "show-date": false,
                    "show-job-sequence": true,
                    "show-bill": true,
                    "default-pattern": "",
                    remark: "说明:提单流水号最长16位。"
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.DomesticStatement"),
                  name: "BillingGroupInternalNo"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "BillingGroupInternalNo",
                    "tab-title": _vm.$t("SystemMaintenance.DomesticStatement"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.DomesticStatement"
                    ),
                    "show-op": false,
                    "show-lob": false,
                    "show-net-code": true,
                    "show-user-code": false,
                    "show-port": false,
                    "show-io": false,
                    "show-bill-date": true,
                    "default-pattern": "${office}${YY}${MM}${SSSS:OFM}${io}"
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("SystemMaintenance.ForeignStatement"),
                  name: "BillingGroupNo"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "BillingGroupNo",
                    "tab-title": _vm.$t("SystemMaintenance.ForeignStatement"),
                    "tab-number-title": _vm.$t(
                      "SystemMaintenance.ForeignStatement"
                    ),
                    "show-op": false,
                    "show-lob": false,
                    "show-net-code": true,
                    "show-user-code": false,
                    "show-port": false,
                    "show-io": false,
                    "show-bill-date": true,
                    "default-pattern": "${office}${YY}${MM}${SSSS:OFM}${io}"
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_WriteOffSerialNumber"),
                  name: "WriteOffNo"
                }
              },
              [
                _c("no-config-list", {
                  attrs: {
                    "tab-name": "WriteOffNo",
                    "tab-title": _vm.$t("CargoMsg.Cargo_WriteOffSerialNumber"),
                    "tab-number-title": _vm.$t(
                      "CargoMsg.Cargo_WriteOffSerialNumber"
                    ),
                    "show-op": false,
                    "show-lob": false,
                    "show-user-code": false,
                    "show-port": false,
                    "show-rp": true,
                    "show-io": false,
                    "show-pay-date": true,
                    "default-pattern": "${office}${rp}${YY}${MM}${SSSS:OFM}"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }